import {throwError} from 'rxjs';
import {inject} from '@angular/core';
import {catchError, tap} from 'rxjs/operators';
import {NzNotificationService} from "ng-zorro-antd/notification";
import {httpContextDefaults} from "@app/shared/constants/http-context";
import {HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpResponse} from '@angular/common/http';

export const notifierInterceptor: HttpInterceptorFn = (req, next) => {
  const nzNotificationService = inject(NzNotificationService);
  const params = req.context.get(httpContextDefaults);

  return next(req)
    .pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && params?.notifySuccess) {
          nzNotificationService.success('Success', 'Changes Successfully saved!');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (params?.notifyError && error?.error?.reason) {
          nzNotificationService.error('Error', error.error.reason || 'Something weird happened, please try later!');
        }
        return throwError(() => error);
      })
    );
};

